class ServicesList {
    id;
    serviceNumber;
    serialNumber;
    dateOfregistration;
    name;
    phoneNumber;
    serviceType;
    constructor(id,serviceNumber,serialNumber,dateOfregistration,name,phoneNumber,serviceType){
        this.id=id;
        this.serviceNumber=serviceNumber;
        this.serialNumber=serialNumber;
        this.dateOfregistration=dateOfregistration;
        this.name=name;
        this.phoneNumber=phoneNumber;
        this.serviceType=serviceType;

    }
    getId() {
        return this.id;
      }
}
export {ServicesList}